// extracted by mini-css-extract-plugin
export default {"headerText":"Nutzungsbedingungen_headerText__LovCu","tableColumn1":"Nutzungsbedingungen_tableColumn1__5gwth"};